/*
 * Public API Surface of angular-editor
 */

export * from './angular-editor.service';
export * from './editor/angular-editor.component';
export * from './ae-button/ae-button.component';
export * from './ae-toolbar-set/ae-toolbar-set.component';
export * from './ae-select/ae-select.component';
export * from './ae-toolbar/ae-toolbar.component';
export * from './angular-editor.module';
export { AngularEditorConfig, CustomClass } from './config';
